// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1SFQ-","loading":"styles_loading__MRfTz"};